
import React from 'react';
import { useFormContext } from "react-hook-form";
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface ObservationsSectionProps {
  readOnly?: boolean;
}

const ObservationsSection = ({ readOnly = false }: ObservationsSectionProps) => {
  const { register } = useFormContext();

  return (
    <div className="form-group">
      <Label className="form-label">Observaciones</Label>
      <Textarea 
        {...register('services.serviceNotes')}
        className="form-textarea min-h-[120px]"
        disabled={readOnly}
      />
    </div>
  );
};

export default ObservationsSection;
